import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  className?: string;
}
export function CTAButton({
  text = 'EMPEZAR AHORA',
  className = ''
}: CTAButtonProps) {
  return <motion.a href="https://valordigital.store/cart/46518849142973:1" target="_blank" rel="noopener noreferrer" whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`block w-full max-w-2xl mx-auto bg-gradient-to-b from-[#FFD700] to-[#F6AD37] text-black font-black text-2xl md:text-4xl py-5 px-8 rounded-xl shadow-[0_8px_0_#B45309] hover:shadow-[0_4px_0_#B45309] hover:translate-y-1 transition-all text-center uppercase tracking-tight border-2 border-black ${className}`} data-id="element-49">
      <span className="flex items-center justify-center gap-3" data-id="element-50">
        {text}
        <ArrowRightIcon className="w-8 h-8 md:w-10 md:h-10" strokeWidth={3} data-id="element-51" />
      </span>
    </motion.a>;
}